"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loading = exports.shimmer = void 0;

var _util = require("../../../util");

const shimmer = () => ({
  '0%': {
    backgroundPosition: '-468px 0'
  },
  '100%': {
    backgroundPosition: '468px 0'
  }
});

exports.shimmer = shimmer;

const loading = ({
  cssProps,
  theme
}) => {
  const {
    animation,
    height,
    width
  } = cssProps;
  return {
    animation: "".concat(animation, " 1.25s linear forwards infinite"),
    backgroundColor: (0, _util.color)(theme, 'ui1'),
    background: "linear-gradient(to right, ".concat((0, _util.color)(theme, 'ui1'), " 8%, ").concat((0, _util.color)(theme, 'ui2'), " 18%, ").concat((0, _util.color)(theme, 'ui1'), " 33%)"),
    backgroundSize: '800px 104px',
    height,
    position: 'relative',
    width
  };
};

exports.loading = loading;
//# sourceMappingURL=LoadingBlock.style.js.map